<div class="header-area dark:bg-[#0c1427] py-[10px] px-[20px] md:px-[25px] fixed top-0 z-[6] rounded-b-md transition-all"
    id="header-area">
    <div class="md:flex md:items-center md:justify-between">
        <div class="relative leading-none top-px mr-2">
            <div class="flex flex-row justify-between" style="align-items: baseline!important;">
                <button type="button" class="hide-sidebar-toggle transition-all inline-block hover:text-sky-600"
                    (click)="toggleSidebar()">
                    <mat-icon svgIcon="ulb_menu"></mat-icon>
                </button>
                <div class="header-title">

                </div>
            </div>
        </div>



        <div class="flex flex-row justify-stretch flex-grow flex-shrink items-center">

            <div class="flex-grow flex-shrink">
                <ng-template appDynamicToolbarAnchor></ng-template>
            </div>


            <ul class="flex items-center justify-between gap-x-4 md:justify-normal mt-[13px] m-0 pl-4">
                <li class="relative profile-menu">
                    <button type="button" class="flex items-center relative text-black dark:text-white"
                        id="profileMenuBtn" (click)="toggleClass('profileMenuBtn')"
                        [class.active]="buttonStates['profileMenuBtn']">
                        <img src="../../../assets/images/admin.png"
                            class="w-[25px] h-[25px] md:w-[35px] md:h-[35px] rounded-full border-2 border-Sky-200 inline-block"
                            alt="admin-image">
                        <!-- <span class="block font-semibold text-[0] lg:text-base">
                            User Name
                        </span> -->
                        <!-- <i class="ri-arrow-down-s-line text-[15px] absolute ltr:-right-[3px] rtl:-left-[3px] top-1/2 -translate-y-1/2 mt-px"></i> -->
                    </button>
                    <div
                        class="profile-menu-dropdown bg-white dark:bg-[#0c1427] transition-all shadow-3xl dark:shadow-none py-[15px] absolute mt-[11px] md:mt-[11px] w-[195px] z-[1] top-full rtl:left-0 rounded-md">
                        <div
                            class="flex items-center border-b border-gray-100 dark:border-[#172036] pb-[7px] mx-[20px] mb-[7px]">
                            <!-- <img src="../../../assets/images/admin.png" class="rounded-full w-[31px] h-[31px] ltr:mr-[9px] rtl:ml-[9px] border-2 border-Sky-200 inline-block" alt="admin-image"> -->
                            <div>
                                <!-- <span class="block text-black dark:text-white text-base tracking-normal font-medium">
                                      {{ userInfo()?.fullname }}
                                </span> -->
                                 <span class="block text-black dark:text-white text-base tracking-normal font-medium">
                                       Type: {{ userInfo().fullname }}
                                </span>
                                <span class="block text-xs">
                                       Office: {{ userInfo().office }}
                                </span>
                               
                            </div>
                        </div>
                        <ul>
                            <li>
                                <a matToolTip="User Profile"
                                    class="text-sm block relative py-[7px] ltr:pl-[50px] ltr:pr-[20px] rtl:pr-[50px] rtl:pl-[20px] text-black dark:text-white transition-all hover:text-Sky-600"
                                    (click)="moveToMyProfile()">
                                    <i
                                        class="material-symbols-outlined top-1/2 -translate-y-1/2 !text-[22px] absolute ltr:left-[20px] rtl:right-[20px]">
                                        account_circle
                                    </i>
                                    My Profile
                                </a>
                            </li>
                            <li>
                                <a href="/screenshot/index.html" target="_blank"
                                    class="text-sm block relative py-[7px] ltr:pl-[50px] ltr:pr-[20px] rtl:pr-[50px] rtl:pl-[20px] text-black dark:text-white transition-all hover:text-Sky-600">
                                    <i
                                        class="material-symbols-outlined top-1/2 -translate-y-1/2 !text-[22px] absolute ltr:left-[20px] rtl:right-[20px]">
                                        help
                                    </i>
                                    Help
                                </a>
                            </li>
                            <li>
                                <a routerLink="/dashboard/settings"
                                    class="block relative py-[7px] ltr:pl-[50px] ltr:pr-[20px] rtl:pr-[50px] rtl:pl-[20px] text-black dark:text-white transition-all hover:text-sky-600">
                                    <i
                                        class="material-symbols-outlined top-1/2 -translate-y-1/2 !text-[22px] absolute ltr:left-[20px] rtl:right-[20px]">
                                        settings
                                    </i>
                                    Settings
                                </a>
                            </li>
                        </ul>
                    </div>
                </li>
                <li>
                    <button type="button" matTooltip="Fullscreen" class="leading-none flex items-center"
                        (click)="toggleFullscreen()">
                        <!-- <i class="material-symbols-outlined">
                            {{ isFullscreen ? 'fullscreen_exit' : 'fullscreen' }}
                        </i> -->
                        <!-- <mat-icon svgIcon="ulb_fullscreen"></mat-icon> -->
                        <mat-icon class="material-symbols-outlined">fullscreen</mat-icon>
                    </button>
                </li>

                <!-- <li>
                    <button type="button" class="disable">
                         <mat-icon svgIcon="ulb_filter"></mat-icon>
                    </button>
                </li> -->


                <li>
                    <button (click)="goToDashboard()" mat-icon-button class="settings-icon-sec flex items-center" matTooltip="Home"
                        style="padding: 1.5px ;">
                        <mat-icon class="material-symbols-outlined">home</mat-icon>
                    </button>
                </li>
                <li>
                    <button (click)="logoutfn()" mat-icon-button class="settings-icon-sec flex items-center"
                        matTooltip="Sign Out" style="padding: 1.5px ;">
                        <mat-icon class="material-symbols-outlined">logout</mat-icon>
                    </button>
                </li>


                <!-- <li class="relative settings-menu mx-[8px] md:mx-[10px] lg:mx-[12px] ltr:first:ml-0 ltr:last:mr-0 rtl:first:mr-0 rtl:last:ml-0">
                <button
                    type="button"
                    (click)="toggleClass('settingsMenuBtn')"
                    [class.active]="buttonStates['settingsMenuBtn']"
                    class="leading-none inline-block transition-all relative top-[2px] hover:text-sky-600"
                >
                    <i class="material-symbols-outlined !text-[22px] md:!text-[24px]">
                        settings
                    </i>
                </button>
                <div class="settings-menu-dropdown bg-white dark:bg-[#0c1427] transition-all shadow-3xl dark:shadow-none p-[20px] absolute mt-[17px] md:mt-[20px] w-[195px] z-[1] top-full ltr:right-0 rtl:left-0 rounded-md">
                    <button
                        type="button"
                        (click)="toggleDirection()"
                        class="rtl-mode-toggle flex items-center text-black dark:text-white font-medium"
                    >
                        RTL Mode:
                        <span class="inline-block relative rounded-full w-[35px] h-[20px] bg-gray-50 dark:bg-[#0a0e19] ltr:ml-[10px] rtl:mr-[10px]">
                            <span class="inline-block transition-all absolute h-[12px] w-[12px] bg-black dark:bg-white rounded-full top-1/2 -translate-y-1/2"></span>
                        </span>
                    </button>
                </div>
            </li> -->
            </ul>
        </div>
    </div>
</div>
    <!-- <router-outlet></router-outlet> -->